// extracted by mini-css-extract-plugin
export default {"block":"ve"};